import { render, staticRenderFns } from "./InAds.vue?vue&type=template&id=0953ff3a"
import script from "./InAds.vue?vue&type=script&lang=ts"
export * from "./InAds.vue?vue&type=script&lang=ts"
import style0 from "./InAds.vue?vue&type=style&index=0&id=0953ff3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports